import "./App.scss";
import { router } from "./__product__/navigation/router";
import AppHook from "./AppHook";
// eslint-disable-next-line import/no-extraneous-dependencies
import { CookieConsent } from "react-cookie-consent";
import { useTranslation } from "react-i18next";

function App() {
  AppHook();
  const { t } = useTranslation();
  /**
   * render build method
   */
  return (
    <>
      <CookieConsent
        location="bottom"
        buttonText={t("ok")}
        cookieName="cookie_accept"
        style={{ background: "#ffffff", margin: 8, width: "95%", borderRadius: 8 }}
        contentStyle={{ color: "#232323", fontWeight: "500" }}
        buttonStyle={{ color: "#787474", fontSize: "13px", alignSelf: "flex-end" }}
        expires={150}
      >
        <a
          style={{ textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
          href={"https://iyilestir.net/cerez-politikasi.html"}
        >
          {t("cookie_info")}
        </a>
      </CookieConsent>
      {router()}
    </>
  );
}

export default App;
